module.exports = __webpack_public_path__ + "img/about_report.ddd75cb7.png";